import setAsyncState from '@functions/setAsyncState.ts';
import ArticleT from '@global/models/Article.ts';
import getListItems from '@requests/getListItems.ts';

import I from '../types.ts';

const getItems: I['getItems'] = async function (this: I) {
    const { currentSection, search = '' } = this.state;

    const query = this.getQueryForRequest();

    query.params.push(
        { key: 'inList', value: 'true' },
        { key: 'type', value: 'blog' },
        { key: 'system', value: 'crm' },
    );

    if (currentSection && currentSection !== 'all') {
        query.params.push({ key: 'sections', value: currentSection });
    }

    if (search?.length > 2) {
        query.params.push({ key: 'searchForTitle', value: search });
    }

    const { items, isLimit, counter, sections } = await getListItems<ArticleT, { sections: any[] }>(
        {
            url: 'article',
            query: query.params,
        },
    );

    await this.setItems({ items, isLimit, counter });
    await setAsyncState.call(this, {
        sections: [{ key: 'all', content: 'Все' }, ...(sections || [])],
    });

    return { items };
};

export default getItems;
